// extracted by mini-css-extract-plugin
module.exports = {"image":"about-module--image--30W-N"};